import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "row p-4 bg-gray-light rounded" };
const _hoisted_2 = { class: "col-6" };
const _hoisted_3 = { class: "text-center mb-5" };
const _hoisted_4 = { class: "text-muted" };
const _hoisted_5 = { class: "alt-wrapper" };
const _hoisted_6 = { class: "col-6 d-flex gap-xs flex-column" };
const _hoisted_7 = {
    key: 0,
    class: "row h-100 mb-5 mt-5"
};
const _hoisted_8 = {
    key: 1,
    class: "text-danger"
};
const _hoisted_9 = { key: 2 };
const _hoisted_10 = { class: "row mb-5" };
const _hoisted_11 = { class: "col-6 p-1 position-relative" };
const _hoisted_12 = { class: "crop-gallery" };
const _hoisted_13 = ["src"];
const _hoisted_14 = { class: "col-6 p-1 position-relative" };
const _hoisted_15 = { class: "crop-cover" };
const _hoisted_16 = ["src"];
const _hoisted_17 = { class: "row" };
const _hoisted_18 = { class: "col-6 p-1 position-relative" };
const _hoisted_19 = { class: "crop-lista" };
const _hoisted_20 = ["src"];
const _hoisted_21 = { class: "col-6 p-1 position-relative" };
const _hoisted_22 = { class: "crop-quadrata" };
const _hoisted_23 = ["src"];
const _hoisted_24 = { class: "d-flex footer-buttons" };
import { ref, toRef, computed, onMounted } from 'vue';
import BaseModal from '../BaseModal.vue';
import UiImageEditor from '../UiImageEditor.vue';
import InputComponent from '../Input.vue';
import ButtonComponent from '../Button.vue';
import VueElementLoading from 'vue-element-loading';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ImgEditModal',
    props: ['isModalOpened', 'initialData'],
    emits: ['handleSubmit', 'onCloseModal', 'handleNewUpload', 'onRemoveImg'],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emits = __emit;
        const isModalOpened = toRef(props, 'isModalOpened');
        const initialData = toRef(props, 'initialData');
        const croppedImg = ref(null);
        const thumbImg = ref(null);
        const croppedSize = ref(null);
        const issue = ref(null);
        const isErr = ref(false);
        const isLoading = ref(false);
        const imgAltText = ref([
            {
                key: "Alt-It",
                value: "",
                languageCode: "it"
            },
            {
                key: "Alt-En",
                value: "",
                languageCode: "en"
            },
        ]);
        const isEdit = computed(() => initialData.value?.card);
        const onSubmit = () => {
            emits('handleSubmit', {
                card: croppedImg.value,
                thumb: thumbImg.value,
            });
            onCloseModal();
        };
        const onCloseModal = () => {
            emits('onCloseModal');
        };
        const handleImgCropped = (img, width, height) => {
            croppedImg.value = img;
            croppedSize.value = { width, height };
            if (width < 380 || height < 475) {
                issue.value = "L'immagine non ha le dimensioni minime necessarie. (380x475)";
                isErr.value = true;
            }
            else {
                issue.value = null;
                isErr.value = false;
            }
            // Create a thumbnail image with 40px by 40px
            const targetWidth = 40;
            const targetHeight = 40;
            const resizedCanvas = document.createElement('canvas');
            resizedCanvas.width = targetWidth;
            resizedCanvas.height = targetHeight;
            const ctx = resizedCanvas.getContext('2d');
            const image = new Image();
            image.src = img;
            image.onload = () => {
                ctx.drawImage(image, 0, 0, targetWidth, targetHeight);
                thumbImg.value = resizedCanvas.toDataURL();
            };
        };
        const onNewUpload = () => {
            emits('handleNewUpload', initialData.value?.uuid);
        };
        const onRemoveImg = () => {
            emits('onRemoveImg', initialData.value?.uuid);
        };
        const onLoaded = () => {
            isLoading.value = false;
        };
        const handleAltText = (text) => {
            if (text?.lang === 'it') {
                imgAltText.value[0].value = text.text;
            }
            else if (text?.lang === 'en') {
                imgAltText.value[1].value = text.text;
            }
        };
        onMounted(() => {
            isLoading.value = true;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(BaseModal, {
                isOpen: isModalOpened.value,
                onModalClose: onCloseModal,
                onSubmit: onSubmit,
                name: "edit-modal"
            }, {
                header: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                        _createElementVNode("h1", { class: "font-display-4" }, "Modifica dell'immagine", -1)
                    ]))]),
                content: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _createVNode(UiImageEditor, {
                                img: initialData.value?.full,
                                onImgCroppedChanged: handleImgCropped,
                                onOnLoaded: onLoaded
                            }, null, 8, ["img"]),
                            _createElementVNode("p", _hoisted_3, [
                                _cache[1] || (_cache[1] = _createTextVNode(" Cropped Size: ", -1)),
                                _createElementVNode("small", _hoisted_4, _toDisplayString(croppedSize.value?.width) + " * " + _toDisplayString(croppedSize.value?.height), 1)
                            ]),
                            _createElementVNode("div", _hoisted_5, [
                                _createVNode(InputComponent, {
                                    title: "Testo alternativo",
                                    "max-number": 50,
                                    text: imgAltText.value[0].value,
                                    placeholder: "Inserisci il testo alternativo",
                                    language: "it",
                                    onHandleText: handleAltText
                                }, null, 8, ["text"]),
                                _createVNode(InputComponent, {
                                    title: "Alt Text",
                                    "max-number": 50,
                                    text: imgAltText.value[1].value,
                                    placeholder: "Enter Alt Text",
                                    language: "en",
                                    onHandleText: handleAltText
                                }, null, 8, ["text"])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_6, [
                            _cache[6] || (_cache[6] = _createElementVNode("h3", null, "Anteprime in app:", -1)),
                            (isLoading.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                    _createVNode(_unref(VueElementLoading), {
                                        active: isLoading.value,
                                        spinner: "spinner",
                                        color: "#2D489D"
                                    }, null, 8, ["active"])
                                ]))
                                : (isErr.value)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(issue.value), 1))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                        _createElementVNode("div", _hoisted_10, [
                                            _createElementVNode("div", _hoisted_11, [
                                                _createElementVNode("div", _hoisted_12, [
                                                    _createElementVNode("img", {
                                                        src: croppedImg.value,
                                                        alt: "cropped-img"
                                                    }, null, 8, _hoisted_13)
                                                ]),
                                                _cache[2] || (_cache[2] = _createElementVNode("p", { class: "preview-img-label" }, "Gallery", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_14, [
                                                _createElementVNode("div", _hoisted_15, [
                                                    _createElementVNode("img", {
                                                        src: croppedImg.value,
                                                        alt: "cropped-img"
                                                    }, null, 8, _hoisted_16)
                                                ]),
                                                _cache[3] || (_cache[3] = _createElementVNode("p", { class: "preview-img-label" }, "Cover", -1))
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_17, [
                                            _createElementVNode("div", _hoisted_18, [
                                                _createElementVNode("div", _hoisted_19, [
                                                    _createElementVNode("img", {
                                                        src: croppedImg.value,
                                                        alt: "cropped-img"
                                                    }, null, 8, _hoisted_20)
                                                ]),
                                                _cache[4] || (_cache[4] = _createElementVNode("p", { class: "preview-img-label" }, "Lista", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_21, [
                                                _createElementVNode("div", _hoisted_22, [
                                                    _createElementVNode("img", {
                                                        src: croppedImg.value,
                                                        alt: "cropped-img"
                                                    }, null, 8, _hoisted_23)
                                                ]),
                                                _cache[5] || (_cache[5] = _createElementVNode("p", { class: "preview-img-label" }, "Quadrata", -1))
                                            ])
                                        ])
                                    ]))
                        ])
                    ])
                ]),
                footer: _withCtx(() => [
                    _createElementVNode("div", _hoisted_24, [
                        _createVNode(ButtonComponent, {
                            text: "Annulla",
                            type: "primary",
                            class: "bg-red",
                            onHandleClick: onCloseModal
                        }),
                        (isEdit.value)
                            ? (_openBlock(), _createBlock(ButtonComponent, {
                                key: 0,
                                text: "Elimina",
                                type: "remove",
                                class: "bg-red border-red",
                                isDisable: isLoading.value,
                                onHandleClick: onRemoveImg
                            }, null, 8, ["isDisable"]))
                            : _createCommentVNode("", true),
                        _createVNode(ButtonComponent, {
                            text: "Sostituisci",
                            type: "regular",
                            class: "bg-white",
                            isDisable: isLoading.value,
                            onHandleClick: onNewUpload
                        }, null, 8, ["isDisable"]),
                        _createVNode(ButtonComponent, {
                            text: "Conferma",
                            type: "primary",
                            class: "bg-primary-custom",
                            isDisable: isErr.value || isLoading.value,
                            onHandleClick: onSubmit
                        }, null, 8, ["isDisable"])
                    ])
                ]),
                _: 1
            }, 8, ["isOpen"]));
        };
    }
});
